module.exports = __webpack_public_path__ + "static/media/press-thumb-01.4f3c38d1.jpg";